/* src/app/fee-level/presenter/fee-level-presenter.component.scss */
:host ::ng-deep .fee,
:host ::ng-deep .feehistory {
  height: calc(100% - 60px);
  overflow: visible;
}
:host ::ng-deep .p-checkbox-label {
  margin-bottom: 0;
}
:host ::ng-deep .tabulator-header-filter {
  height: 2.2em;
}
:host ::ng-deep .p-accordion-content {
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  padding-right: 0.5em;
  padding-left: 0.5em;
  overflow: visible;
}
:host ::ng-deep .p-accordion-tab {
  overflow: visible;
}
:host ::ng-deep .fee-level-first-panel {
  position: relative;
  isolation: isolate;
}
:host ::ng-deep .fee-level-table-container {
  box-sizing: border-box;
  overflow: hidden !important;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
:host ::ng-deep .fee-level-table-container p-table {
  flex: 1 1 0;
  min-height: 0;
  display: block;
}
:host ::ng-deep .fee-level-table-container .p-datatable-table-container {
  flex: 1;
  min-height: 0;
  overflow: hidden !important;
}
:host ::ng-deep div[ng-reflect-ng-style*=height] {
  box-sizing: border-box;
}
:host ::ng-deep div[ng-reflect-ng-style*=height] .p-datatable {
  height: 100%;
}
:host ::ng-deep .p-datatable {
  height: 100%;
  overflow: hidden;
}
:host ::ng-deep .p-datatable .p-datatable-wrapper {
  overflow: hidden;
  height: 100%;
}
:host ::ng-deep .p-datatable .p-datatable-scrollable-wrapper {
  overflow: hidden;
  height: 100%;
}
:host ::ng-deep .p-datatable .p-datatable-scrollable-view {
  height: 100%;
}
:host ::ng-deep .p-datatable .p-datatable-scrollable-view .p-datatable-scrollable-header {
  height: 6.5em;
}
:host ::ng-deep .p-datatable .p-datatable-scrollable-view .p-datatable-scrollable-body {
  overflow: auto !important;
  height: calc(100% - 6.5em);
}
:host ::ng-deep .p-datatable .p-datatable-scrollable-view .p-datatable-scrollable-body table {
  min-width: 1200px;
}
:host ::ng-deep .p-datatable .p-datatable-header {
  padding: 0.5em;
}
:host ::ng-deep .ng-tns-c115-28 .p-calendar {
  width: 15em;
}
:host ::ng-deep .p-datatable-scrollable-body::-webkit-scrollbar {
  height: 12px;
  width: 12px;
}
:host ::ng-deep .p-datatable-scrollable-body::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 6px;
}
:host ::ng-deep .p-datatable-scrollable-body::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 6px;
}
:host ::ng-deep .p-datatable-scrollable-body::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
:host ::ng-deep .p-datatable-scrollable-body::-webkit-scrollbar-corner {
  background: #f1f1f1;
}
:host ::ng-deep .p-accordion {
  overflow: visible;
}
.highlight-input {
  background-color: lightgoldenrodyellow;
}
.blinking {
  animation: blinking 2000ms infinite;
}
@keyframes blinking {
  0% {
    color: black;
    background-color: lightgoldenrodyellow;
  }
  50% {
    color: black;
    background-color: lightyellow;
  }
  100% {
    color: black;
    background-color: white;
  }
}
/*# sourceMappingURL=fee-level-presenter.component.css.map */
